module.exports = __webpack_public_path__ + "img/logo_centros_excelencia.67ff27b6.jpg";